export function ClickLog() {
  return (
    <div className="space-y-6">
      {/* Summary Cards — Coming soon */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {['Total Clicks', 'Total Postbacks', 'Match Rate', 'Avg Payout'].map(label => (
          <div key={label} className="bg-slate-900 border border-slate-800 rounded-xl p-5 shadow-sm">
            <span className="text-xs font-medium text-slate-500 uppercase tracking-wider">{label}</span>
            <p className="text-2xl font-bold text-slate-600 mt-1">—</p>
            <p className="text-xs text-slate-700 mt-0.5">Data not yet connected</p>
          </div>
        ))}
      </div>

      {/* Coming soon panel */}
      <div className="bg-slate-900 border border-slate-800 rounded-xl p-12 shadow-sm flex flex-col items-center justify-center gap-4">
        <div className="w-14 h-14 rounded-full bg-slate-800 flex items-center justify-center">
          <svg className="w-7 h-7 text-slate-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M13 10V3L4 14h7v7l9-11h-7z" />
          </svg>
        </div>
        <div className="text-center">
          <h4 className="text-slate-300 font-semibold text-sm mb-1">Click & Postback Logs — Coming Soon</h4>
          <p className="text-slate-500 text-xs max-w-sm">
            Real-time click tracking and postback matching logs will appear here once the tracker integration is live.
            This feature requires the click tracker pipeline to be connected.
          </p>
        </div>
      </div>
    </div>
  );
}
